import { createFileRoute } from '@tanstack/react-router'
import { RunResultsPage } from '@/pages/run-results'

export const Route = createFileRoute('/_authenticated/runs/$runId')({
  component: RunResultsPage,
})
